var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenieBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "158px",
    height: "212px",
    viewBox: "0 0 158 212",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B5C714C-583C-4B1D-AA1C-2E83FC411D4A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-menu",
    transform: "translate(-604, -129)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Genie-big",
    transform: "translate(604, 129)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.16,
    fill: "#1B1B1B",
    cx: 74.8909807,
    cy: 202.399556,
    rx: 53.4409424,
    ry: 9.4307471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13869193,117.489497 C17.7256754,159.318259 62.8509477,181.731867 104.840531,168.32644 C152.898092,152.716059 164.622498,106.551308 153.760763,73.1115029 L132.349119,7.19270241 C130.574708,1.73270956 124.693036,-1.2528115 119.207242,0.503190203 L53.0457857,21.9939146 C19.525887,32.9078853 -11.4197709,69.5911736 4.13869193,117.489497 Z",
    id: "Path",
    fill: "#33CC66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.781569,116.190267 C109.583953,138.029606 88.299415,150.071063 68.4168354,148.65755 C48.5340974,147.242453 29.1688036,132.308437 26.0763272,109.808246 C25.7760545,107.779466 28.0229553,106.402834 29.7767885,107.444528 C38.333215,112.514182 52.7230361,116.487216 70.6008958,117.610429 C88.455962,119.054175 103.289623,117.135564 112.452927,113.326517 C114.336556,112.543466 116.365969,114.224486 115.781569,116.190267 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieBig);
export default __webpack_public_path__ + "static/media/Genie-big.029d33c90fd36453685889c1a6e9ecce.svg";
export { ForwardRef as ReactComponent };